import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import i18n from 'i18next';
import { PersistGate } from 'redux-persist/integration/react';
import './index.css';
import App from './view/App';
import * as serviceWorker from './serviceWorker';
import createStore from './state/reducers';
import './conf/i18n';
import AppActions from './state/actions/AppActions';

window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;

const { store, persistor } = createStore();
i18n.on('languageChanged', (lang) =>
  store.dispatch(AppActions.languageChanged(lang))
);

render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.js